import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { FunctionalCapabilitiesOfferManagementPage } from 'src/app/model/page/group/api-docs/functional-capabilities-offer-management-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-functional-capabilities-offer-management-page',
  templateUrl: './functional-capabilities-offer-management-page.component.html',
  styleUrls: ['./functional-capabilities-offer-management-page.component.scss']
})
export class FunctionalCapabilitiesOfferManagementPageComponent implements OnInit {
  @Input() apiName: string = '';
  @Input() apiTabs: string[] = [];
  @Input() apiTabsClass: string[] = [];
  @Input() pageTitle: string = '';
  @Input() isTab: boolean = false;
  @Input() href: string = '';
  @Input() isTabOverride: boolean = false;
  @Input() selectedIndex: number = 0;

  functionalCapabilitiesOfferManagementPage: FunctionalCapabilitiesOfferManagementPage = {} as FunctionalCapabilitiesOfferManagementPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInitWithPageTitle(pageTitle: string) {
    // console.log('>>>> >>>> FunctionalCapabilitiesOfferManagementPageComponent invoked ngOnInitWithPageTitle');

    this.selectedIndex = 0;

    this.apiTabs.forEach((tab, index) => {
      if (this.apiName + ' ' + tab === pageTitle) {
        this.selectedIndex = index;
      }
    });

    this.setPageTitle(pageTitle);
  }

  setPageTitle(value: string) {
    // console.log(value);

    if (value.length > 0) {
      this.pageTitle = value;
    }

    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'functional-capabilities-offer-management') {
        this.functionalCapabilitiesOfferManagementPage.htmlTitle = title.htmlTitle;
      }
    });
    // console.log('apiName : ' + this.apiName);
    // console.log('pageTitle : ' + this.pageTitle);

    const query = { 'fields.title': this.pageTitle };
    this.contentfulService.getPageContentResponse(query).then((offermanagementPageEntries) => {
      this.functionalCapabilitiesOfferManagementPage.introductionSections = [];
      this.functionalCapabilitiesOfferManagementPage.ribbonTileSections = [];
      this.functionalCapabilitiesOfferManagementPage.tableSections = [];
      this.functionalCapabilitiesOfferManagementPage.xmlSections = [];
      this.functionalCapabilitiesOfferManagementPage.xmlAroundTable = [];
      this.functionalCapabilitiesOfferManagementPage.noteSections = [];
      this.functionalCapabilitiesOfferManagementPage.samplesintroductionSections = [];

      this.mapBanner(offermanagementPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.functionalCapabilitiesOfferManagementPage.banner);
      this.mapSection(offermanagementPageEntries.includes.Entry);
      this.mapTableSection(offermanagementPageEntries.includes.Entry);
      this.mapNoteSection(offermanagementPageEntries.includes.Entry);
      this.mapPageInfo(offermanagementPageEntries.items);
    });
  }

  private mapBanner(offermanagementPageEntries: Entry<any>[]) {
    offermanagementPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.functionalCapabilitiesOfferManagementPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  private mapSection(offerManagementPageSectionEntry: Entry<any>[]) {
    offerManagementPageSectionEntry
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case 'introduction':
            this.mapEntryToSection(entry);
            break;
          case 'samples-introduction':
            this.mapEntryToSamplesIntroductionSection(entry);
            break;
          case 'ribbon-tile':
            this.mapEntryToRibbonTileSection(entry);
            break;
          case 'xml':
            this.mapEntryToXMLSection(entry);
            break;
          case 'table':
            this.mapEntryToTableSection(entry);
            break;
          case 'xml-around-table':
            this.mapEntryToXMLSectionAroundTable(entry);
            break;
          default:
            console.error('New group Found - ' + entry.fields['title']);
            break;
        }
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.functionalCapabilitiesOfferManagementPage.introductionSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      heading: entry.fields['heading'] as string
    });
    this.functionalCapabilitiesOfferManagementPage.introductionSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSamplesIntroductionSection(entry: Entry<any>) {
    this.functionalCapabilitiesOfferManagementPage.samplesintroductionSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      heading: entry.fields['heading'] as string
    });
    this.functionalCapabilitiesOfferManagementPage.samplesintroductionSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToXMLSectionAroundTable(entry: Entry<any>) {

    if(entry.fields['xml'] !== 'undefined'){

    
    let givenXmlTitle:any=entry.fields['xml'];
    let xmlReponseTitle:any=givenXmlTitle.content[0].data.target.fields.title as string;
    let xmlTitle =xmlReponseTitle.split('#').pop();

    this.httpClient.get(givenXmlTitle.content[0].data.target.fields.file.url, { responseType: 'text' }).subscribe({
      next: (data) => this.mapEntryToTableSectionAroundXMLData(entry, data, xmlTitle),
      error: (cause) => this.mapEntryToTableSectionAroundXMLData(entry, '', '')
    });
  }
    else
  {
    this.mapEntryToTableSectionAroundXMLData(entry, '', '');
  }
}


  private mapEntryToRibbonTileSection(entry: Entry<any>) {
    let tBody: string[] = [];
     let pageBody=entry.fields['body'] as string;
     pageBody.split('@').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.functionalCapabilitiesOfferManagementPage.ribbonTileSections.push({
      title: pageTitle,
      body: '',
      bodyArrows: tBody,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string
    });
    this.functionalCapabilitiesOfferManagementPage.ribbonTileSections.sort((a, b) => a.order - b.order);
  }
  private mapTableSection(offerManagementTableEntrySection: Entry<any>[]) {
    offerManagementTableEntrySection
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#')[2];
    this.functionalCapabilitiesOfferManagementPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string, 
      group: entry.fields['group'] as string, 
      order: entry.fields['order'] as number, 
      table: entry.fields['table'] as string, 
      heading: entry.fields['heading'] as string, 
    });
    // console.log('table section', this.functionalCapabilitiesOfferManagementPage.tableSections);

    this.functionalCapabilitiesOfferManagementPage.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToTableSectionAroundXMLData(entry: Entry<any>, xmlData: string, xmlTitle: string) {
    this.functionalCapabilitiesOfferManagementPage.xmlAroundTable.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry.fields['subBody'] as string,
      xmlTitle: xmlTitle,
      xmlData: xmlData,
      heading: entry.fields['heading'] as string
    });
    this.functionalCapabilitiesOfferManagementPage.xmlAroundTable.sort((a, b) => a.order - b.order);
  }

  private mapEntryToXMLSection(entry: Entry<any>) {
    if(typeof entry.fields['xml'] !== 'undefined'){
    let givenXmlTitle:any=entry.fields['xml'];
    let xmlReponseTitle:any=givenXmlTitle?.content[0]?.data?.target?.fields?.title as string;

    let xmlTitle = xmlReponseTitle?.split('#').pop();
    this.httpClient.get(givenXmlTitle.content[0].data.target.fields?.file.url, { responseType: 'text' }).subscribe({
      next: (data) => this.mapEntryToIntroductionSectionWithXMLData(entry, data, xmlTitle),
      error: (cause) => this.mapEntryToIntroductionSectionWithXMLData(entry, '', '')
    });
  }
  else
  {
    this.mapEntryToIntroductionSectionWithXMLData(entry, '', '');
  }
  }

  private mapEntryToIntroductionSectionWithXMLData(entry: Entry<any>, xmlData: string, xmlTitle: string) {
    this.functionalCapabilitiesOfferManagementPage.xmlSections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry.fields['subBody'] as string,
      xmlTitle: xmlTitle,
      xmlData: xmlData,
      heading: entry.fields['heading'] as string
    });
    this.functionalCapabilitiesOfferManagementPage.xmlSections.sort((a, b) => a.order - b.order);
  }

  private mapNoteSection(entry: Entry<any>[]) {
    entry.filter((entry) => ModelValidator.isNote(entry));
    entry.forEach((entry) => {
      if (entry.fields['group'] === 'note') {
        this.mapEntryToNoteSection(entry);
      }
    });
  }

  private mapEntryToNoteSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();



    this.functionalCapabilitiesOfferManagementPage.noteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: entry.fields['title'] as string,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
    this.functionalCapabilitiesOfferManagementPage.noteSections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.functionalCapabilitiesOfferManagementPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.functionalCapabilitiesOfferManagementPage.banner.url = entry.fields?.url;
      this.functionalCapabilitiesOfferManagementPage.banner.editorEmail = editorDetails?.pop();
      this.functionalCapabilitiesOfferManagementPage.banner.editorShortName = editorDetails?.pop();
      this.functionalCapabilitiesOfferManagementPage.banner.editorFullName = editorDetails?.pop();
      this.functionalCapabilitiesOfferManagementPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
